'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const HotelFilters = () => {
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [starRating, setStarRating] = useState<number[]>([]);
  const [amenities, setAmenities] = useState<string[]>([]);
  const [propertyType, setPropertyType] = useState<string[]>([]);

  const toggleFilter = (value: string | number, currentFilters: (string | number)[], setFilters: (filters: any[]) => void) => {
    if (currentFilters.includes(value)) {
      setFilters(currentFilters.filter(f => f !== value));
    } else {
      setFilters([...currentFilters, value]);
    }
  };

  const amenitiesList = [
    { name: 'Free WiFi', icon: 'WifiIcon' },
    { name: 'Pool', icon: 'HomeIcon' },
    { name: 'Parking', icon: 'TruckIcon' },
    { name: 'Restaurant', icon: 'BuildingStorefrontIcon' },
    { name: 'Gym', icon: 'HeartIcon' },
    { name: 'Spa', icon: 'SparklesIcon' },
    { name: 'Pet Friendly', icon: 'HeartIcon' },
    { name: 'Airport Shuttle', icon: 'TruckIcon' },
  ];

  const propertyTypes = [
    'Hotel',
    'Resort',
    'Apartment',
    'Villa',
    'Hostel',
    'Guesthouse',
  ];

  return (
    <div className="bg-card rounded-lg shadow-brand p-6 space-y-6 sticky top-20">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-lg font-semibold text-foreground">Filters</h3>
        <button className="text-sm text-primary hover:text-secondary transition-colors font-bold">
          Clear all
        </button>
      </div>

      {/* Price Range */}
      <div className="space-y-3">
        <h4 className="font-medium text-foreground flex items-center space-x-2">
          <Icon name="CurrencyDollarIcon" size={18} className="text-muted-foreground" />
          <span>Price per Night</span>
        </h4>
        <div className="space-y-2">
          <input
            type="range"
            min="0"
            max="1000"
            value={priceRange[1]}
            onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value)])}
            className="w-full"
          />
          <div className="flex items-center justify-between text-sm text-muted-foreground font-bold">
            <span>${priceRange[0]}</span>
            <span>${priceRange[1]}</span>
          </div>
        </div>
      </div>

      {/* Star Rating */}
      <div className="space-y-3">
        <h4 className="font-medium text-foreground flex items-center space-x-2">
          <Icon name="StarIcon" size={18} className="text-muted-foreground" />
          <span>Star Rating</span>
        </h4>
        <div className="space-y-2">
          {[5, 4, 3, 2, 1].map((stars) => (
            <label key={stars} className="flex items-center space-x-2 cursor-pointer group">
              <input
                type="checkbox"
                checked={starRating.includes(stars)}
                onChange={() => toggleFilter(stars, starRating, setStarRating)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
              />
              <div className="flex items-center space-x-1">
                {Array.from({ length: stars }).map((_, i) => (
                  <Icon key={i} name="StarIcon" size={14} className="text-accent" variant="solid" />
                ))}
              </div>
            </label>
          ))}
        </div>
      </div>

      {/* Property Type */}
      <div className="space-y-3">
        <h4 className="font-medium text-foreground flex items-center space-x-2">
          <Icon name="BuildingOffice2Icon" size={18} className="text-muted-foreground" />
          <span>Property Type</span>
        </h4>
        <div className="space-y-2">
          {propertyTypes.map((type) => (
            <label key={type} className="flex items-center space-x-2 cursor-pointer group">
              <input
                type="checkbox"
                checked={propertyType.includes(type)}
                onChange={() => toggleFilter(type, propertyType, setPropertyType)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
              />
              <span className="text-sm text-foreground group-hover:text-primary transition-colors font-bold">
                {type}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Amenities */}
      <div className="space-y-3">
        <h4 className="font-medium text-foreground flex items-center space-x-2">
          <Icon name="CheckCircleIcon" size={18} className="text-muted-foreground" />
          <span>Amenities</span>
        </h4>
        <div className="space-y-2">
          {amenitiesList.map((amenity) => (
            <label key={amenity.name} className="flex items-center space-x-2 cursor-pointer group">
              <input
                type="checkbox"
                checked={amenities.includes(amenity.name)}
                onChange={() => toggleFilter(amenity.name, amenities, setAmenities)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-primary"
              />
              <span className="text-sm text-foreground group-hover:text-primary transition-colors font-bold">
                {amenity.name}
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HotelFilters;